<template>
  <NFormItem v-if="!outOfTime" class="text-center" v-bind="formItemBaseAttrs">
    <span class="n-invite-reg-timer-remaining">({{ remainingTime }}s)</span>
  </NFormItem>
  <div class="n-form-item" v-else>
    <NButton type="text" size="small" class="extra-btn n-invite-reg-timer-resend-btn" :disabled="loading" @click="resend">
      <template #icon><reload-outlined /></template>
      <span class="!text-xs n-invite-reg-timer-resend">{{ $tl('resend') }}</span>
    </NButton>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, useAttrs, watch} from 'vue';
import {useFormItemBaseAttrs} from './hooks/useFormItemBaseAttrs';
import {NButton} from "@/components";

const attrs = useAttrs();

const props = defineProps({
  label: String,
  name: [String, Array],
  customLabel: String,
  seconds: { type: Number, default: 60 },
  loading: { type: Boolean, default: false },
});

const { formItemBaseAttrs, componentBaseAttrs } = useFormItemBaseAttrs(props);

const componentAttrs = computed(() => ({
  ...componentBaseAttrs.value,
  ...attrs,
}));

const emits = defineEmits(['timeOut', 'onResend', 'reSchedule']);
const remainingTime = computed(() => props.seconds);
const outOfTime = computed(() => props.seconds <= 0);

async function resend(){
  emits('onResend');
}

</script>

<script>
export default {
  name: 'NInviteTimer',
  inheritAttrs: false,
};
</script>

<style lang="less">
.n-invite-reg-timer-remaining {
  color: #777777;
  text-align: center;
}
.n-invite-reg-timer-resend {
  color: rgb(66, 133, 244);
}
.n-invite-reg-timer-resend-btn {
  height: 32px;
  .ant-form-item {
    margin: 0 !important;
  }
}
</style>